
import Map from "./Map";
import Personalinfo from "./Personalinfo";


const ContactUs = () => {

    return (
        <>
        <section class="cards-section light-olive" id="contact-us">
            <div class="container">
                <h2 class="section-title">Contact Us</h2>

                <div class="cards-grid">
                    <Personalinfo />
                    <Map/>
                </div>
            </div>
        </section>
        </>
    );
}

export default ContactUs;